import { AuthenticatedTemplate } from "@azure/msal-react";
import { ReactElement, useContext, useEffect } from "react";
import { ApplicationLocationContext } from "../../Common/UI/utils/ApplicationState";
import { pageNames } from "../../authConfig";
import Store from "./Store";
import { PageContainer } from "../../Common/UI/components/PageContainer";

function StoreInfoView(): ReactElement {
  const { state, setState } = useContext(ApplicationLocationContext);

  useEffect(() => {
    setState({
      path: [pageNames.store411],
    });
  }, []);

  return (
    <AuthenticatedTemplate>
      <PageContainer>
        <Store />
      </PageContainer>
    </AuthenticatedTemplate>
  );
}

export default StoreInfoView;
